import {ChangeEvent} from "react";

/**
 * Workaround for input mask issue where the caret position is lost on change.
 * This function should be used in the onChange event of an input field.
 * Remove it when the issue is resolved in the `use-mask-input` library.
 *
 * @link https://github.com/eduardoborges/use-mask-input/issues/62#issuecomment-1822592882
 */
export const inputMaskOnChangeWorkaround = (event: ChangeEvent<HTMLInputElement>) => {
    const caret = event.target.selectionStart;
    const element = event.target;

    window.requestAnimationFrame(() => {
        element.selectionStart = caret;
        element.selectionEnd = caret;
    });
};
import {ChangeEvent} from "react";

/**
 * Workaround for input mask issue where the caret position is lost on change.
 * This function should be used in the onChange event of an input field.
 * Remove it when the issue is resolved in the `use-mask-input` library.
 *
 * @link https://github.com/eduardoborges/use-mask-input/issues/62#issuecomment-1822592882
 */
export const inputMaskOnChangeWorkaround = (event: ChangeEvent<HTMLInputElement>) => {
    const caret = event.target.selectionStart;
    const element = event.target;

    window.requestAnimationFrame(() => {
        element.selectionStart = caret;
        element.selectionEnd = caret;
    });
};
